module.exports = __webpack_public_path__ + "img/b04.0edab148.png";